import React from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useNavigator } from '../components/Navigator';
import useNotifier from '../components/Messages/hooks';
import { extractDataError } from '../utils/errors';

const useCreateForm = ({ schema, router, onComplete }) => {
  const navigate = useNavigator();
  const pushMessage = useNotifier();
  const [state, setState] = React.useState({
    errors: [],
    submitLoading: false,
  });
  const [createMutation, createKey] = schema.create();
  const loading = false; // TODO try make loading
  const [doCreate] = useMutation(createMutation, {
    onCompleted: (d) => {
      setState({ ...state, submitLoading: false });
      if (onComplete) {
        onComplete(d);
        return;
      }
      const res = d[createKey];
      if (res.ok) {
        navigate(router.list());
      } else {
        const dataError = extractDataError(res.errors);
        if (dataError) {
          pushMessage({ text: dataError });
        } else {
          window.scrollTo(0, 0);
          // pushMessage({
          //   text: t`Виникла помилка, перевірте чи всі поля заповнені`,
          // });
        }
        setState({ ...state, errors: res.errors, submitLoading: false });
      }
    },
  });

  const onSubmit = (formData) => {
    setState({ ...state, submitLoading: true });
    doCreate({ variables: { inputData: formData } });
  };

  return {
    loading,
    onSubmit,
    errors: state.errors,
    submitLoading: state.submitLoading,
  };
};

export default useCreateForm;
